import styled from "styled-components";
import Card from "react-bootstrap/Card";

const StyledCard = styled(Card)`
  /*  */
`;

export { StyledCard as Card };
